<template>
  <!-- complete Modal -->
  <div class="modal custom-modal fade request-modal" id="complete-court" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <div class="form-header modal-header-title">
            <h4 class="mb-0">
              Court Booking Details<span class="badge bg-warning ms-2">On Going</span>
            </h4>
          </div>
          <a class="close" data-bs-dismiss="modal" aria-label="Close">
            <span class="align-center" aria-hidden="true"><i class="feather-x"></i></span>
          </a>
        </div>
        <div class="modal-body">
          <!-- Court Request -->
          <div class="row">
            <div class="col-lg-12">
              <div class="card dashboard-card court-information">
                <div class="card-header">
                  <h4>Court Information</h4>
                </div>
                <div class="appointment-info">
                  <ul class="appointmentset">
                    <li>
                      <div class="appointment-item">
                        <div class="appointment-img">
                          <img
                            src="@/assets/img/booking/booking-03.jpg"
                            alt="Appointment"
                          />
                        </div>
                        <div class="appointment-content">
                          <h6>Wing Sports Academy</h6>
                          <p class="color-green">Court 1</p>
                        </div>
                      </div>
                    </li>
                    <li>
                      <h6>Booked On</h6>
                      <p>$150 Upto 2 guests</p>
                    </li>
                    <li>
                      <h6>Price Per Guest</h6>
                      <p>$15</p>
                    </li>
                    <li>
                      <h6>Maximum Number of Guests</h6>
                      <p>2</p>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card dashboard-card court-information">
                <div class="card-header">
                  <h4>Appointment Information</h4>
                </div>
                <div class="appointment-info appoin-border">
                  <ul class="appointmentset">
                    <li>
                      <h6>Booked On</h6>
                      <p>Mon, Jul 14</p>
                    </li>
                    <li>
                      <h6>Date & Time</h6>
                      <p>Mon, Jul 14<span class="d-block">05:00 PM - 08:00 PM</span></p>
                    </li>
                    <li>
                      <h6>Total Number of Hours</h6>
                      <p>2</p>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="card dashboard-card court-information">
                <div class="card-header">
                  <h4>Payment Details</h4>
                </div>
                <div class="appointment-info appoin-border double-row">
                  <ul class="appointmentset">
                    <li>
                      <h6>Court Booking Amount</h6>
                      <p>$150</p>
                    </li>
                    <li>
                      <h6>Additional Guests</h6>
                      <p>2</p>
                    </li>
                    <li>
                      <h6>Amount Additional Guests</h6>
                      <p>$30</p>
                    </li>
                    <li>
                      <h6>Service Charge</h6>
                      <p>$20</p>
                    </li>
                  </ul>
                </div>
                <div class="appointment-info appoin-border">
                  <ul class="appointmentsetview">
                    <li>
                      <h6>Total Amount Paid</h6>
                      <p class="color-green">$180</p>
                    </li>
                    <li>
                      <h6>Paid On</h6>
                      <p>Mon, Jul 14</p>
                    </li>
                    <li>
                      <h6>Transaction ID</h6>
                      <p>#5464164445676781641</p>
                    </li>
                    <li>
                      <h6>Payment type</h6>
                      <p>Wallet</p>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card dashboard-card court-information">
                <div class="card-header">
                  <h4>Review Details</h4>
                </div>
                <div class="user-review-details">
                  <div class="user-review-img">
                    <img src="@/assets/img/profiles/avatar-01.jpg" alt="User" />
                  </div>
                  <div class="user-review-content">
                    <div class="table-rating">
                      <div class="rating-point">
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <span>5.0</span>
                      </div>
                    </div>
                    <span
                      ><i class="fa fa-check me-2" aria-hidden="true"></i>Yes, I would
                      book again.</span
                    >
                    <h6>Absolutely perfect</h6>
                    <p>
                      If you are looking for a perfect place for friendly matches with
                      your friends or a competitive match, It is the best place.
                    </p>
                    <h5>Sent on 11/03/2023</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Court Request -->
        </div>
        <div class="modal-footer">
          <div class="table-accept-btn">
            <a href="javascript:;" data-bs-dismiss="modal" class="btn cancel-table-btn"
              >Cancel</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /complete Modal -->

  <!-- complete Modal -->
  <div class="modal custom-modal fade request-modal" id="complete-coach" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <div class="form-header modal-header-title">
            <h4 class="mb-0">
              Coach Booking Details<span class="badge bg-warning ms-2">On Going</span>
            </h4>
          </div>
          <a class="close" data-bs-dismiss="modal" aria-label="Close">
            <span class="align-center" aria-hidden="true"><i class="feather-x"></i></span>
          </a>
        </div>
        <div class="modal-body">
          <!-- Court Request -->
          <div class="row">
            <div class="col-lg-12">
              <div class="card dashboard-card court-information">
                <div class="card-header">
                  <h4>Court Information</h4>
                </div>
                <div class="appointment-info">
                  <ul class="appointmentset">
                    <li>
                      <div class="appointment-item">
                        <div class="appointment-img">
                          <img src="@/assets/img/featured/featured-06.jpg" alt="Venue" />
                        </div>
                        <div class="appointment-content">
                          <h6>Angela Roudrigez</h6>
                          <div class="table-rating">
                            <div class="rating-point">
                              <i class="fas fa-star filled"></i>
                              <i class="fas fa-star filled"></i>
                              <i class="fas fa-star filled"></i>
                              <i class="fas fa-star filled"></i>
                              <i class="fas fa-star filled"></i>
                              <span>30 Reviews</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                    <li>
                      <h6>Location</h6>
                      <p>Santa Monica, CA</p>
                    </li>
                    <li>
                      <h6>Price Per Hour</h6>
                      <p>$200.00 / hr</p>
                    </li>
                    <li>
                      <h6>Rank</h6>
                      <p>Expert</p>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card dashboard-card court-information">
                <div class="card-header">
                  <h4>Appointment Information</h4>
                </div>
                <div class="appointment-info appoin-border">
                  <ul class="appointmentset">
                    <li>
                      <h6>Booked On</h6>
                      <p>Mon, Jul 14</p>
                    </li>
                    <li>
                      <h6>Booking Type</h6>
                      <p>Onetime</p>
                    </li>
                    <li>
                      <h6>Date & Time</h6>
                      <p>Mon, Jul 14 <span>05:00 PM - 08:00 PM</span></p>
                    </li>
                    <li>
                      <h6>Total Number of Hours</h6>
                      <p>2</p>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card dashboard-card court-information">
                <div class="card-header">
                  <h4>Booking Days</h4>
                </div>
                <div class="booking-days">
                  <ul>
                    <li
                      v-for="(item, index) in items"
                      :key="index"
                      @click="toggleActive(index)"
                      :class="{ active: item.active }"
                    >
                      <img src="@/assets/img/icons/reset.svg" class="me-2" alt="Icon" />
                      <i class="feather-check-circle me-2"></i>
                      {{ item.date }} - {{ item.time }}
                      <i class="fa fa-check-circle ms-2"></i>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card dashboard-card court-information">
                <div class="card-header">
                  <h4>Payment Details</h4>
                </div>
                <div class="appointment-info appoin-border double-row">
                  <ul class="appointmentset">
                    <li>
                      <h6>Coaching Booking Amount</h6>
                      <p>$200</p>
                    </li>
                    <li>
                      <h6>Number of Hours</h6>
                      <p>2</p>
                    </li>
                    <li>
                      <h6>Service Charge</h6>
                      <p>$20</p>
                    </li>
                  </ul>
                </div>
                <div class="appointment-info appoin-border">
                  <ul class="appointmentset">
                    <li>
                      <h6>Total Amount Paid</h6>
                      <p class="color-green">$180</p>
                    </li>
                    <li>
                      <h6>Paid On</h6>
                      <p>Mon, Jul 14</p>
                    </li>
                    <li>
                      <h6>Transaction ID</h6>
                      <p>#5464164445676781641</p>
                    </li>
                    <li>
                      <h6>Payment type</h6>
                      <p>Wallet</p>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="card dashboard-card court-information">
                <div class="card-header">
                  <h4>Review Details</h4>
                </div>
                <div class="user-review-details">
                  <div class="user-review-img">
                    <img src="@/assets/img/profiles/avatar-01.jpg" alt="User" />
                  </div>
                  <div class="user-review-content">
                    <div class="table-rating">
                      <div class="rating-point">
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <i class="fas fa-star filled"></i>
                        <span>5.0</span>
                      </div>
                    </div>
                    <span
                      ><i class="fa fa-check me-2" aria-hidden="true"></i>Yes, I would
                      book again.</span
                    >
                    <h6>Absolutely perfect</h6>
                    <p>
                      If you are looking for a perfect place for friendly matches with
                      your friends or a competitive match, It is the best place.
                    </p>
                    <h5>Sent on 11/03/2023</h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Court Request -->
        </div>
        <div class="modal-footer">
          <div class="table-accept-btn">
            <a href="javascript:;" data-bs-dismiss="modal" class="btn cancel-table-btn"
              >Cancel</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /complete Modal -->

  <!-- profile Modal -->
  <div class="modal custom-modal fade request-modal" id="profile-coach" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <div class="form-header modal-header-title">
            <h4 class="mb-0">Coach Profile</h4>
          </div>
          <a class="close" data-bs-dismiss="modal" aria-label="Close">
            <span class="align-center" aria-hidden="true"><i class="feather-x"></i></span>
          </a>
        </div>
        <div class="modal-body">
          <!-- Court Request -->
          <div class="row">
            <div class="col-lg-12">
              <div class="card dashboard-card court-information">
                <div class="profile-set">
                  <div class="profile-set-image">
                    <img src="@/assets/img/featured/featured-05.jpg" alt="Venue" />
                  </div>
                  <div class="profile-set-content">
                    <h3>Kevin Anderson</h3>
                    <div class="rating-city">
                      <div class="profile-set-rating">
                        <span>4.5</span>
                        <h6>300 Reviews</h6>
                      </div>
                      <div class="profile-set-img">
                        <img src="@/assets/img/flag/usa.png" alt="Profile" />
                        <h6>Santamanica, United states</h6>
                      </div>
                    </div>
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and typesetting
                      industry.industry's
                    </p>
                    <ul>
                      <li>
                        <img src="@/assets/img/icons/rank.svg" alt="Icon" />
                        <h6>Rank : Expert</h6>
                      </li>
                      <li>
                        <img src="@/assets/img/icons/process.svg" alt="Icon" />
                        <h6>Sessions Completed : 25</h6>
                      </li>
                      <li>
                        <img src="@/assets/img/icons/calendar-alt.svg" alt="Icon" />
                        <h6>With Dreamsport since<span> Apr 5, 2023</span></h6>
                      </li>
                    </ul>
                  </div>
                  <div class="price-set-price">
                    <h6>Start’s From</h6>
                    <h5>$250<span>/hr</span></h5>
                  </div>
                </div>
              </div>
              <div class="profile-tab">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="profile-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#profile"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Profile Info
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="appointment-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#appointment"
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      Appointment Details
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="reviews-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#reviews"
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      Reviews
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="previous-tab"
                      data-bs-toggle="tab"
                      data-bs-target="#previous"
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      Previous Booking
                    </button>
                  </li>
                </ul>
                <div class="tab-content">
                  <div
                    class="tab-pane fade show active"
                    id="profile"
                    role="tabpanel"
                    aria-labelledby="profile-tab"
                  >
                    <div class="profile-card mb-0">
                      <div class="profile-card-title">
                        <h4>Contact Information</h4>
                      </div>
                      <div class="profile-contact-details">
                        <ul>
                          <li>
                            <span>Email Address</span>
                            <h6>contact@example.com</h6>
                          </li>
                          <li>
                            <span>Phone Number</span>
                            <h6>+1 56565 556558</h6>
                          </li>
                          <li>
                            <span> Address</span>
                            <h6>1653 Davisson Street,Indianapolis, IN 46225</h6>
                          </li>
                        </ul>
                      </div>
                      <div class="profile-card-title">
                        <h4>Short Bio</h4>
                      </div>
                      <div class="profile-card-content">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Varius
                          consectetur a at est diam ultricies. Egestas eros leo dapibus
                          tellus neque turpis. Nec in morbi adipiscing pretium accumsan
                          urna ac,Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                          Varius consectetur a at est diam ultricies. Egestas eros leo
                          dapibus tellus neque turpis. Nec in morbi adipiscing pretium
                          accumsan urna ac,Lorem ipsum dolor sit amet, consectetur
                          adipiscing elit. Varius consectetur a at est diam ultricies.
                          Egestas eros leo dapibus tellus neque turpis. Nec in morbi
                          adipiscing pretium accumsan urna ac,
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="appointment"
                    role="tabpanel"
                    aria-labelledby="appointment-tab"
                  >
                    <!-- Accordian Contents -->
                    <div class="accordion" id="accordionPanel">
                      <div class="accordion-item mb-4" id="short-bio">
                        <h4 class="accordion-header" id="panelsStayOpen-short-bio">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#panelsStayOpen-collapseOne"
                            aria-expanded="true"
                            aria-controls="panelsStayOpen-collapseOne"
                          >
                            <span class="icon-bg"
                              ><img src="@/assets/img/icons/short-bio.svg" alt="Icon"
                            /></span>
                            Short Bio
                          </button>
                        </h4>
                        <div
                          id="panelsStayOpen-collapseOne"
                          class="accordion-collapse collapse show"
                          aria-labelledby="panelsStayOpen-short-bio"
                        >
                          <div class="accordion-body">
                            <div class="text show-more-height">
                              <p>
                                Lorem Ipsum is simply dummy text of the printing and
                                typesetting industry. Lorem Ipsum has been the industry's
                                standard dummy text ever since the 1500s, when an unknown
                                printer took a galley of type and scrambled it to make a
                                type specimen book. It has survived not only five
                                centuries, but also the leap into electronic typesetting,
                                remaining essentially unchanged. It was popularised in the
                                1960s with the release of Letraset sheets containing Lorem
                                Ipsum passages, and more recently with desktop publishing
                                software like Aldus PageMaker including versions of Lorem
                                Ipsum
                              </p>

                              <ul>
                                <li>4 years of high school (3 years varsity)</li>
                                <li>
                                  3 years of college club badminton at Loyola Marymount
                                </li>
                                <li>
                                  I grew up at North Venice Little League and represented
                                </li>
                                <li>
                                  Southern California in 2017 for Senior State Champs.
                                </li>
                                <li>
                                  3 years on Varsity at Venice High School. Venice Varsity
                                </li>
                                <li>badminton Western League Champs 2017.</li>
                                <li>
                                  2 years of Loyola Marymount University Club badminton.
                                </li>
                              </ul>

                              <p>
                                It was popularised in the 1960s with the release of
                                Letraset sheets containing Lorem Ipsum passages, and more
                                recently with desktop publishing software like Aldus
                                PageMaker including versions of Lorem Ipsum
                              </p>

                              <p>
                                Lorem Ipsum is simply dummy text of the printing and
                                typesetting industry. Lorem Ipsum has been the industry's
                                standard dummy text ever since the 1500s, when an unknown
                                printer took a galley of type and scrambled it to make a
                                type specimen book. It has survived not only five
                                centuries, but also the leap into electronic typesetting,
                                remaining essentially unchanged. It was popularised in the
                                1960s with the release of Letraset sheets containing Lorem
                                Ipsum passages, and more recently with desktop publishing
                                software like Aldus PageMaker including versions of Lorem
                                Ipsum
                              </p>

                              <p>
                                Lorem Ipsum is simply dummy text of the printing and
                                typesetting industry. Lorem Ipsum has been the industry's
                                standard dummy text ever since the 1500s, when an unknown
                                printer took a galley of type and scrambled it to make a
                                type specimen book. It has survived not only five
                                centuries, but also the leap into electronic typesetting,
                                remaining essentially unchanged.
                              </p>

                              <p>
                                It was popularised in the 1960s with the release of
                                Letraset sheets containing Lorem Ipsum passages, and more
                                recently with desktop publishing software like Aldus
                                PageMaker including versions of Lorem Ipsum
                              </p>
                            </div>
                            <div class="show-more d align-items-center primary-text">
                              <i class="feather-plus-circle"></i>Show More
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item mb-4" id="lesson-with-me">
                        <h4 class="accordion-header" id="panelsStayOpen-lesson-with-me">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#panelsStayOpen-collapseTwo"
                            aria-expanded="false"
                            aria-controls="panelsStayOpen-collapseTwo"
                          >
                            <span class="icon-bg"
                              ><img
                                src="@/assets/img/icons/lesson-with-me.svg"
                                alt="Icon"
                            /></span>
                            Lesson With me
                          </button>
                        </h4>
                        <div
                          id="panelsStayOpen-collapseTwo"
                          class="accordion-collapse collapse show"
                          aria-labelledby="panelsStayOpen-lesson-with-me"
                        >
                          <div class="accordion-body">
                            <p>
                              Lorem Ipsum is simply dummy text of the printing and
                              typesetting industry. Lorem Ipsum has been the industry's
                              standard dummy text ever since the 1500s, when an unknown
                              printer took a galley of type and scrambled it to make a
                              type specimen book. It has survived not only five centuries,
                              but also the leap into electronic typesetting, remaining
                              essentially unchanged. It was popularised in the 1960s with
                              the release of Letraset sheets containing Lorem Ipsum
                              passages, and more recently with desktop publishing software
                              like Aldus PageMaker including versions of Lorem Ipsum
                            </p>
                            <ul>
                              <li><i class="feather-check-square"></i>Single Lesson</li>
                              <li><i class="feather-check-square"></i>2 Player Lesson</li>
                              <li>
                                <i class="feather-check-square"></i>Small group Lesson
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item mb-4" id="coaching">
                        <h4 class="accordion-header" id="panelsStayOpen-coaching">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#panelsStayOpen-collapseThree"
                            aria-expanded="false"
                            aria-controls="panelsStayOpen-collapseThree"
                          >
                            <span class="icon-bg"
                              ><img src="@/assets/img/icons/coaching.svg" alt="Icon"
                            /></span>
                            Coaching
                          </button>
                        </h4>
                        <div
                          id="panelsStayOpen-collapseThree"
                          class="accordion-collapse collapse show"
                          aria-labelledby="panelsStayOpen-coaching"
                        >
                          <div class="accordion-body">
                            <p>
                              Lorem Ipsum is simply dummy text of the printing and
                              typesetting industry. Lorem Ipsum has been the industry's
                              standard dummy text ever since the 1500s, when an unknown
                              printer took a galley of type and scrambled it to make a
                              type specimen book. It has survived not only five centuries,
                              but also the leap into electronic typesetting, remaining
                              essentially unchanged. It was popularised in the 1960s with
                              the release of Letraset sheets containing Lorem Ipsum
                              passages, and more recently with desktop publishing software
                              like Aldus PageMaker including versions of Lorem Ipsum
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item mb-4" id="gallery">
                        <h4 class="accordion-header" id="panelsStayOpen-gallery">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#panelsStayOpen-collapseFive"
                            aria-expanded="false"
                            aria-controls="panelsStayOpen-collapseFive"
                          >
                            <span class="icon-bg"
                              ><img src="@/assets/img/icons/gallery.svg" alt="Icon"
                            /></span>
                            Gallery
                          </button>
                        </h4>
                        <div
                          id="panelsStayOpen-collapseFive"
                          class="accordion-collapse collapse show"
                          aria-labelledby="panelsStayOpen-gallery"
                        >
                          <div class="accordion-body">
                            <div class="owl-carousel gallery-slider owl-theme">
                              <carousel-modal></carousel-modal>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item" id="location">
                        <h4 class="accordion-header" id="panelsStayOpen-location">
                          <button
                            class="accordion-button"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#panelsStayOpen-collapseSeven"
                            aria-expanded="false"
                            aria-controls="panelsStayOpen-collapseSeven"
                          >
                            <span class="icon-bg"
                              ><img src="@/assets/img/icons/location.svg" alt="Icon"
                            /></span>
                            Location
                          </button>
                        </h4>
                        <div
                          id="panelsStayOpen-collapseSeven"
                          class="accordion-collapse collapse show"
                          aria-labelledby="panelsStayOpen-location"
                        >
                          <div class="accordion-body">
                            <div class="google-maps">
                              <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2967.8862835683544!2d-73.98256668525309!3d41.93829486962529!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89dd0ee3286615b7%3A0x42bfa96cc2ce4381!2s132%20Kingston%20St%2C%20Kingston%2C%20NY%2012401%2C%20USA!5e0!3m2!1sen!2sin!4v1670922579281!5m2!1sen!2sin"
                                height="170"
                                style="border: 0"
                                allowfullscreen=""
                                loading="lazy"
                                referrerpolicy="no-referrer-when-downgrade"
                              ></iframe>
                            </div>
                            <div
                              class="dull-bg d-flex justify-content-start align-items-center mb-3"
                            >
                              <div class="white-bg me-2">
                                <i class="fas fa-location-arrow"></i>
                              </div>
                              <div class="">
                                <h6>Our Venue Location</h6>
                                <p>70 Bright St New York, USA</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Accordian Contents -->
                  </div>
                  <div
                    class="tab-pane fade"
                    id="reviews"
                    role="tabpanel"
                    aria-labelledby="reviews-tab"
                  >
                    <div class="review-box review-box-user d-flex">
                      <div class="review-profile">
                        <img
                          src="@/assets/img/profiles/avatar-01.jpg"
                          class="img-fluid"
                          alt="User"
                        />
                      </div>
                      <div class="review-info">
                        <h6 class="mb-2 tittle">Amanda Booked on 06/04/2023</h6>
                        <div class="rating">
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <span class="">5.0</span>
                        </div>
                        <span class="success-text"
                          ><i class="feather-check"></i>Yes, I would book again.</span
                        >
                        <h6>Absolutely perfect</h6>
                        <p>
                          If you are looking for a perfect place for friendly matches with
                          your friends or a competitive match, It is the best place.
                        </p>
                        <ul class="review-gallery">
                          <li>
                            <a
                              href="assets/img/gallery/gallery-01.jpg"
                              data-fancybox="gallery"
                            >
                              <img
                                class="img-fluid"
                                alt="Image"
                                src="@/assets/img/gallery/gallery-01.jpg"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              href="assets/img/gallery/gallery-02.jpg"
                              data-fancybox="gallery"
                            >
                              <img
                                class="img-fluid"
                                alt="Image"
                                src="@/assets/img/gallery/gallery-02.jpg"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              href="assets/img/gallery/gallery-03.jpg"
                              data-fancybox="gallery"
                            >
                              <img
                                class="img-fluid"
                                alt="Image"
                                src="@/assets/img/gallery/gallery-03.jpg"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              href="assets/img/gallery/gallery-04.jpg"
                              data-fancybox="gallery"
                            >
                              <img
                                class="img-fluid"
                                alt="Image"
                                src="@/assets/img/gallery/gallery-04.jpg"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              href="assets/img/gallery/gallery-05.jpg"
                              data-fancybox="gallery"
                            >
                              <img
                                class="img-fluid"
                                alt="Image"
                                src="@/assets/img/gallery/gallery-05.jpg"
                              />
                            </a>
                          </li>
                        </ul>
                        <span class="post-date">Sent on 11/03/2023</span>
                      </div>
                    </div>
                    <div class="review-box review-box-user d-flex">
                      <div class="review-profile">
                        <img
                          src="@/assets/img/profiles/avatar-01.jpg"
                          class="img-fluid"
                          alt="User"
                        />
                      </div>
                      <div class="review-info">
                        <h6 class="mb-2 tittle">Amanda Booked on 06/04/2023</h6>
                        <div class="rating">
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <span class="">5.0</span>
                        </div>
                        <h6>Awesome. Its very convenient to play.</h6>
                        <p>
                          Lorem Ipsum is simply dummy text of the printing and typesetting
                          industry. Lorem Ipsum has been the industry's standard dummy
                          text ever since the 1500s, when an unknown printer took a galley
                          of type and scrambled it to make a type specimen book. It has
                          survived not only five centuries, but also the leap into
                          electronic!!
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="previous"
                    role="tabpanel"
                    aria-labelledby="previous-tab"
                  >
                    <div class="preview-tab">
                      <ul>
                        <li>
                          <div class="preview-tabcontent">
                            <div class="preview-tabimg">
                              <img
                                src="@/assets/img/services/service-01.jpg"
                                alt="Service"
                              />
                            </div>
                            <div class="preview-tabname">
                              <h4>Leap Sports Academy</h4>
                              <h5>Court 1</h5>
                              <ul>
                                <li><span>Guests : 4</span></li>
                                <li><span>2 Hrs</span></li>
                              </ul>
                            </div>
                          </div>
                        </li>
                        <li>
                          <h6>Date & Time</h6>
                          <span class="d-block">Mon, Jul 11</span>
                          <span>06:00 PM - 08:00 PM</span>
                        </li>
                        <li>
                          <h6>$400</h6>
                        </li>
                      </ul>
                    </div>
                    <div class="preview-tab">
                      <ul>
                        <li>
                          <div class="preview-tabcontent">
                            <div class="preview-tabimg">
                              <img
                                src="@/assets/img/services/service-02.jpg"
                                alt="Service"
                              />
                            </div>
                            <div class="preview-tabname">
                              <h4>Marsh Academy</h4>
                              <h5>Court 1</h5>
                              <ul>
                                <li><span>Guests : 4</span></li>
                                <li><span>2 Hrs</span></li>
                              </ul>
                            </div>
                          </div>
                        </li>
                        <li>
                          <h6>Date & Time</h6>
                          <span class="d-block">Mon, Jul 11</span>
                          <span>06:00 PM - 08:00 PM</span>
                        </li>
                        <li>
                          <h6>$300</h6>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Court Request -->
        </div>
      </div>
    </div>
  </div>
  <!-- /upcoming Modal -->

  <!-- profile Modal -->
  <div class="modal custom-modal fade request-modal" id="profile-court" role="dialog">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content">
        <div class="modal-header">
          <div class="form-header modal-header-title">
            <h4 class="mb-0">Coach Profile</h4>
          </div>
          <a class="close" data-bs-dismiss="modal" aria-label="Close">
            <span class="align-center" aria-hidden="true"><i class="feather-x"></i></span>
          </a>
        </div>
        <div class="modal-body">
          <!-- Court Request -->
          <div class="row">
            <div class="col-lg-12">
              <div class="master-academy dull-whitesmoke-bg card master-academyview">
                <div class="row d-flex align-items-center justify-content-center">
                  <div class="col-12 col-sm-12 col-md-12 col-lg-8">
                    <div class="d-sm-flex justify-content-start align-items-center">
                      <a href="javascript:void(0);"
                        ><img
                          class="corner-radius-10"
                          src="@/assets/img/master-academy.png"
                          alt="Academy"
                      /></a>
                      <div class="info">
                        <h3 class="mb-2">Manchester Academy</h3>
                        <div class="profile-set-content w-100 p-0">
                          <ul class="bg-transparent p-0">
                            <li>
                              <img src="@/assets/img/icons/location.svg" alt="Icon" />
                              <h6>70 Bright St New York, USA</h6>
                            </li>
                            <li>
                              <img src="@/assets/img/icons/call.svg" alt="Icon" />
                              <h6>+3 80992 31212</h6>
                            </li>
                            <li>
                              <img src="@/assets/img/icons/mail.svg" alt="Icon" />
                              <h6>yourmail@example.com</h6>
                            </li>
                          </ul>
                        </div>
                        <div class="coach-profile-set">
                          <ul class="bg-transparent p-0">
                            <li>
                              <div class="coach-profile-set-img">
                                <img src="@/assets/img/icons/indoor.svg" alt="Icon" />
                              </div>
                              <div class="coach-profile-set-contemt">
                                <h5>Venue</h5>
                                <span> Indoor</span>
                              </div>
                            </li>
                            <li>
                              <div class="coach-profile-set-img">
                                <img
                                  src="@/assets/img/profiles/avatar-01.jpg"
                                  alt="User"
                                />
                              </div>
                              <div class="coach-profile-set-contemt">
                                <h5>Venue</h5>
                                <span> Indoor</span>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-4">
                    <ul class="d-sm-flex align-items-center justify-content-evenly">
                      <li>
                        <h3 class="d-inline-block">$150</h3>
                        <span>/hr</span>
                        <p>up to 1 guests</p>
                      </li>
                      <li>
                        <span><i class="feather-plus"></i></span>
                      </li>
                      <li class="text-center">
                        <h3 class="d-inline-block">$5</h3>
                        <span>/hr</span>
                        <p>each additional guest <br />up to 4 guests max</p>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="profile-tab">
                <ul class="nav nav-tabs" role="tablist">
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link active"
                      id="profile-tab1"
                      data-bs-toggle="tab"
                      data-bs-target="#profile1"
                      type="button"
                      role="tab"
                      aria-selected="true"
                    >
                      Profile Info
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="appointment-tab1"
                      data-bs-toggle="tab"
                      data-bs-target="#appointment1"
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      Appointment Details
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="reviews-tab1"
                      data-bs-toggle="tab"
                      data-bs-target="#reviews1"
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      Reviews
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button
                      class="nav-link"
                      id="previous-tab1"
                      data-bs-toggle="tab"
                      data-bs-target="#previous1"
                      type="button"
                      role="tab"
                      aria-selected="false"
                    >
                      Previous Booking
                    </button>
                  </li>
                </ul>
                <div class="tab-content">
                  <div
                    class="tab-pane fade show active"
                    id="profile1"
                    role="tabpanel"
                    aria-labelledby="profile-tab1"
                  >
                    <div class="profile-card mb-0">
                      <div class="profile-card-title">
                        <h4>Contact Information</h4>
                      </div>
                      <div class="profile-contact-details mb-0">
                        <ul>
                          <li>
                            <span>Email Address</span>
                            <h6>contact@example.com</h6>
                          </li>
                          <li>
                            <span>Phone Number</span>
                            <h6>+1 56565 556558</h6>
                          </li>
                          <li>
                            <span> Address</span>
                            <h6>1653 Davisson Street,Indianapolis, IN 46225</h6>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="appointment1"
                    role="tabpanel"
                    aria-labelledby="appointment-tab1"
                  >
                    <!-- Accordian Contents -->
                    <div class="accordion">
                      <div class="accordion-item mb-4">
                        <h4 class="accordion-header">
                          <button class="accordion-button" type="button">
                            <span class="icon-bg"
                              ><img src="@/assets/img/icons/Black.svg" alt="Icon" /></span
                            >Overview
                          </button>
                        </h4>
                        <div class="accordion-collapse">
                          <div class="accordion-body">
                            <div class="text">
                              <p>
                                Lorem Ipsum is simply dummy text of the printing and
                                typesetting industry. Lorem Ipsum has been the industry's
                                standard dummy text ever since the 1500s, when an unknown
                                printer took a galley of type and scrambled it to make a
                                type specimen book. It has survived not only five
                                centuries, but also the leap into electronic typesetting,
                                remaining essentially unchanged. It was popularised in the
                                1960s with the release of Letraset sheets containing Lorem
                                Ipsum passages, and more recently with desktop publishing
                                software like Aldus PageMaker including versions of Lorem
                                Ipsum
                              </p>
                              <p>
                                Lorem Ipsum is simply dummy text of the printing and
                                typesetting industry. Lorem Ipsum has been the industry's
                                standard dummy text ever since the 1500s, when an unknown
                                printer took a galley of type and scrambled it to make a
                                type specimen book. It has survived not only five
                                centuries, but also the leap into electronic typesetting,
                                remaining essentially unchanged.
                              </p>
                              <p>
                                It was popularised in the 1960s with the release of
                                Letraset sheets containing Lorem Ipsum passages, and more
                                recently with desktop publishing software like Aldus
                                PageMaker including versions of Lorem IpsumLorem Ipsum is
                                simply dummy text of the printing and typesetting
                                industry. Lorem Ipsum has been the industry's standard
                                dummy text ever since the 1500s, when an unknown printer
                                took a galley of type and scrambled it to make a type
                                specimen book. It has survived not only five centuries,
                                but also the leap into electronic typesetting, remaining
                                essentially unchanged.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item mb-4">
                        <h4 class="accordion-header">
                          <button class="accordion-button" type="button">
                            <span class="icon-bg"
                              ><img
                                src="@/assets/img/icons/lesson-with-me.svg"
                                alt="Icon"
                            /></span>
                            Rules
                          </button>
                        </h4>
                        <div class="accordion-collapse">
                          <div class="accordion-body">
                            <p>
                              <i class="feather-alert-octagon text-danger me-2"></i>Non
                              Marking Shoes are recommended not mandatory for Badminton.
                            </p>
                            <p>
                              <i class="feather-alert-octagon text-danger me-2"></i>A
                              maximum number of members per booking per badminton court is
                              admissible fixed by Venue Vendors
                            </p>
                            <p>
                              <i class="feather-alert-octagon text-danger me-2"></i>No
                              pets, no seeds, no gum, no glass, no hitting or swinging
                              outside of the cage
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item mb-4">
                        <h4 class="accordion-header">
                          <button class="accordion-button" type="button">
                            <span class="icon-bg"
                              ><img
                                src="@/assets/img/icons/lesson-with-me.svg"
                                alt="Icon"
                            /></span>
                            Amenities
                          </button>
                        </h4>
                        <div class="accordion-collapse">
                          <div class="accordion-body">
                            <ul class="amenities-set">
                              <li>
                                <span
                                  ><i
                                    class="fa fa-check-circle text-success me-2"
                                    aria-hidden="true"
                                  ></i
                                  >Parking</span
                                >
                              </li>
                              <li>
                                <span
                                  ><i
                                    class="fa fa-check-circle text-success me-2"
                                    aria-hidden="true"
                                  ></i
                                  >Drinking Water</span
                                >
                              </li>
                              <li>
                                <span
                                  ><i
                                    class="fa fa-check-circle text-success me-2"
                                    aria-hidden="true"
                                  ></i
                                  >First Aid</span
                                >
                              </li>
                              <li>
                                <span
                                  ><i
                                    class="fa fa-check-circle text-success me-2"
                                    aria-hidden="true"
                                  ></i
                                  >Change Room</span
                                >
                              </li>
                              <li>
                                <span
                                  ><i
                                    class="fa fa-check-circle text-success me-2"
                                    aria-hidden="true"
                                  ></i
                                  >Shower</span
                                >
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item mb-4">
                        <h4 class="accordion-header">
                          <button class="accordion-button" type="button">
                            <span class="icon-bg"
                              ><img src="@/assets/img/icons/includes1.svg" alt="Icon"
                            /></span>
                            Includes
                          </button>
                        </h4>
                        <div class="accordion-collapse">
                          <div class="accordion-body includes-set">
                            <ul>
                              <li>
                                <i class="feather-check-square"></i>Badminton Racket
                                Unlimited
                              </li>
                              <li><i class="feather-check-square"></i>Bats</li>
                              <li>
                                <i class="feather-check-square"></i>Hitting Machines
                              </li>
                              <li><i class="feather-check-square"></i>Multiple Courts</li>
                            </ul>
                            <ul>
                              <li><i class="feather-check-square"></i>Spare Players</li>
                              <li><i class="feather-check-square"></i>Instant Racket</li>
                              <li>
                                <i class="feather-check-square"></i>Hitting Machines
                              </li>
                              <li><i class="feather-check-square"></i>Green Turfs</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item mb-4">
                        <h4 class="accordion-header">
                          <button class="accordion-button" type="button">
                            <span class="icon-bg"
                              ><img src="@/assets/img/icons/gallery.svg" alt="Icon"
                            /></span>
                            Gallery
                          </button>
                        </h4>
                        <div class="accordion-collapse">
                          <div class="accordion-body">
                            <div class="owl-carousel gallery-slider owl-theme">
                              <Carousel
                                :wrap-around="true"
                                :settings="settings"
                                :breakpoints="breakpoints"
                              >
                                <Slide
                                  v-for="record in BookingOne_Modal"
                                  :key="record.id"
                                >
                                  <div>
                                    <img
                                      class="img-fluid"
                                      alt="Gallery"
                                      :src="
                                        require(`@/assets/img/gallery/gallery4/${record.Image}`)
                                      "
                                    />
                                  </div>
                                </Slide>
                                <template #addons>
                                  <Navigation />
                                </template>
                              </Carousel>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- Accordian Contents -->
                  </div>
                  <div
                    class="tab-pane fade"
                    id="reviews1"
                    role="tabpanel"
                    aria-labelledby="reviews-tab1"
                  >
                    <div class="review-box review-box-user d-flex">
                      <div class="review-profile">
                        <img
                          src="@/assets/img/profiles/avatar-01.jpg"
                          class="img-fluid"
                          alt="User"
                        />
                      </div>
                      <div class="review-info">
                        <h6 class="mb-2 tittle">Amanda Booked on 06/04/2023</h6>
                        <div class="rating">
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <span class="">5.0</span>
                        </div>
                        <span class="success-text"
                          ><i class="feather-check"></i>Yes, I would book again.</span
                        >
                        <h6>Absolutely perfect</h6>
                        <p>
                          If you are looking for a perfect place for friendly matches with
                          your friends or a competitive match, It is the best place.
                        </p>
                        <ul class="review-gallery">
                          <li>
                            <a
                              href="assets/img/gallery/gallery-01.jpg"
                              data-fancybox="gallery"
                            >
                              <img
                                class="img-fluid"
                                alt="Image"
                                src="@/assets/img/gallery/gallery-01.jpg"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              href="assets/img/gallery/gallery-02.jpg"
                              data-fancybox="gallery"
                            >
                              <img
                                class="img-fluid"
                                alt="Image"
                                src="@/assets/img/gallery/gallery-02.jpg"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              href="assets/img/gallery/gallery-03.jpg"
                              data-fancybox="gallery"
                            >
                              <img
                                class="img-fluid"
                                alt="Image"
                                src="@/assets/img/gallery/gallery-03.jpg"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              href="assets/img/gallery/gallery-04.jpg"
                              data-fancybox="gallery"
                            >
                              <img
                                class="img-fluid"
                                alt="Image"
                                src="@/assets/img/gallery/gallery-04.jpg"
                              />
                            </a>
                          </li>
                          <li>
                            <a
                              href="assets/img/gallery/gallery-05.jpg"
                              data-fancybox="gallery"
                            >
                              <img
                                class="img-fluid"
                                alt="Image"
                                src="@/assets/img/gallery/gallery-05.jpg"
                              />
                            </a>
                          </li>
                        </ul>
                        <span class="post-date">Sent on 11/03/2023</span>
                      </div>
                    </div>
                    <div class="review-box review-box-user d-flex">
                      <div class="review-profile">
                        <img
                          src="@/assets/img/profiles/avatar-01.jpg"
                          class="img-fluid"
                          alt="User"
                        />
                      </div>
                      <div class="review-info">
                        <h6 class="mb-2 tittle">Amanda Booked on 06/04/2023</h6>
                        <div class="rating">
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <i class="fas fa-star filled"></i>
                          <span class="">5.0</span>
                        </div>
                        <h6>Awesome. Its very convenient to play.</h6>
                        <p>
                          Lorem Ipsum is simply dummy text of the printing and typesetting
                          industry. Lorem Ipsum has been the industry's standard dummy
                          text ever since the 1500s, when an unknown printer took a galley
                          of type and scrambled it to make a type specimen book. It has
                          survived not only five centuries, but also the leap into
                          electronic!!
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="previous1"
                    role="tabpanel"
                    aria-labelledby="previous-tab1"
                  >
                    <div class="preview-tab">
                      <ul>
                        <li>
                          <div class="preview-tabcontent">
                            <div class="preview-tabimg">
                              <img
                                src="@/assets/img/featured/featured-05.jpg"
                                alt="Venue"
                              />
                            </div>
                            <div class="preview-tabname">
                              <h4>Kevin Anderson</h4>
                              <h5>Onetime</h5>
                            </div>
                          </div>
                        </li>
                        <li>
                          <h6>Date & Time</h6>
                          <span class="d-block">Mon, Jul 11</span>
                          <span>06:00 PM - 08:00 PM</span>
                        </li>
                        <li>
                          <h6>$400</h6>
                        </li>
                      </ul>
                    </div>
                    <div class="preview-tab">
                      <ul>
                        <li>
                          <div class="preview-tabcontent">
                            <div class="preview-tabimg">
                              <img
                                src="@/assets/img/featured/featured-06.jpg"
                                alt="Venue"
                              />
                            </div>
                            <div class="preview-tabname">
                              <h4>Evon Raddick</h4>
                              <h5>Onetime</h5>
                            </div>
                          </div>
                        </li>
                        <li>
                          <h6>Date & Time</h6>
                          <span class="d-block">Mon, Jul 11</span>
                          <span>06:00 PM - 08:00 PM</span>
                        </li>
                        <li>
                          <h6>$300</h6>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Court Request -->
        </div>
      </div>
    </div>
  </div>
  <!-- /profile Modal -->
</template>
<script>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import BookingOne_Modal from "@/assets/json/bookingone-modal.json";
export default {
  data() {
    return {
      items: [
        { date: "14 May 2023", time: "7:00 PM", active: true },
        { date: "15 May 2023", time: "7:00 PM", active: true },
      ],
      BookingOne_Modal: BookingOne_Modal,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        991: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 4,
          snapAlign: "start",
        },
      },
    };
  },
  methods: {
    toggleActive(index) {
      this.items[index].active = !this.items[index].active;
    },
  },
  components: {
    Carousel,
    Slide,
    Navigation,
  },
};
</script>
